import { formatKpiBadgeValue, formatKpiScaleValue, toFiniteNumber } from "./kpiFormatters";

function kpiUnit(denominator) {
  if (denominator.format === "percent") return "percent";
  if (denominator.format === "hourly") return "currencyPerHour";
  return "currency";
}

// Badge values and differences contain numbers only. The chart renders the
// selected unit once, alongside the denominator control.
export function formatScatterValue(value, denominator) {
  const number = toFiniteNumber(value);
  if (number === null) return "—";
  if (denominator.format === "ratio") return number.toFixed(2);
  return formatKpiBadgeValue(number, kpiUnit(denominator));
}

export function isScatterDifferenceZero(value, denominator) {
  const number = toFiniteNumber(value);
  if (number === null) return true;
  const scaled = denominator.format === "percent" ? number * 100 : number;
  return Number(Math.abs(scaled).toFixed(denominator.decimals)) === 0;
}

export function formatScatterAxisValue(value, denominator, currency = "CHF") {
  const number = toFiniteNumber(value);
  if (number === null) return "—";
  if (denominator.format === "ratio") return `${number.toFixed(2)}x`;
  return formatKpiScaleValue(number, kpiUnit(denominator), currency);
}
